// react
import React from 'react';

// application
import { Search20Svg } from '../../svg';

function Search() {
    return (
        <div className="search" style={{ width: '40vw' }}>
            <form className="search__form" action="">
                <input
                    className="search__input"
                    name="search"
                    placeholder="Search over 500 games"
                    aria-label="Site search"
                    autoComplete="off"
                    id="search"
                />
                <button className="search__button" type="submit">
                    <Search20Svg />
                </button>
                <div className="search__border" />
            </form>
        </div>
    );
}

export default Search;
